export default __webpack_public_path__ + "static/media/user.02816ac6.svg";